'use client';

import {
  useGetUserGlobalEvents,
  useGetUserSoloEvents,
} from '@wwe-portal/web/providers/queries/rbe';

export const useGetClaimableRewardsInMenu = () => {
  const { userGlobalEvents, isLoading: isGlobalEventsLoading } =
    useGetUserGlobalEvents();
  const { data: soloEventSection, isLoading: isSoloEventSectionLoading } =
    useGetUserSoloEvents();

  if (isGlobalEventsLoading || isSoloEventSectionLoading) {
    return {
      totalRewards: 0,
    };
  }

  const totalGlobalRewards =
    userGlobalEvents?.reduce((acc, event) => {
      return (
        acc + event.milestones.filter((item) => item.type === 'claim').length
      );
    }, 0) ?? 0;
  const totalSoloRewards =
    soloEventSection?.reduce((acc, event) => {
      return (
        acc + event.milestones.filter((item) => item.type === 'claim').length
      );
    }, 0) ?? 0;

  const totalRewards = totalGlobalRewards + totalSoloRewards;
  return {
    totalRewards,
  };
};

export const ClaimableRewardsInMenu = () => {
  const { totalRewards } = useGetClaimableRewardsInMenu();
  if (!totalRewards) return null;
  return (
    <>
      <span className="bg-textColor12 absolute right-[43px] top-[-5px] size-1.5 rounded-full" />
      <span
        data-id="left-sidebar-claim-rewards-count"
        className="text-textColor12 mt-[5px] text-xs leading-none"
      >
        Claim {totalRewards} reward{totalRewards > 1 ? 's' : ''}
      </span>
    </>
  );
};

export const ClaimableRewardsInMenuV2 = () => {
  const { totalRewards } = useGetClaimableRewardsInMenu();
  if (!totalRewards) return null;
  return (
    <span
      data-id="left-sidebar-claim-rewards-count"
      className="text-error pr-2 text-[0.5rem] leading-none"
    >
      <em>
        Claim {totalRewards} reward{totalRewards !== 1 ? 's' : ''}
      </em>
    </span>
  );
};
